import {Injectable} from '@angular/core';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import { Effect, Actions } from '@ngrx/effects';

import * as categoryActions from './../actions/category.actions';
import {Observable} from 'rxjs/Observable';
import {ProductService} from '../shared/product.service';
import {Branch} from '../models/Branch';

@Injectable()
export class CategoriesEffect {

  constructor(
    private productService: ProductService, 
    private actions$: Actions
  ) { }

  @Effect()
  loadProducts$: Observable<categoryActions.CategoryAction> = this.actions$
    .ofType(categoryActions.LOAD_CATEGORIES)
    .switchMap(() => {
        return this.productService.getCategoriesFromBackend() 
          .map( (categories : Branch[]) => new categoryActions.LoadCategoriesSuccessAction(categories));
      }
    );
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/effects/categories.effects.ts